<!-- eslint-disable max-len -->
<template>
	<div :class="{ 'vn-open': isOpen }">
		<a
			href="#main-container"
			class="vn-skip-to-main"
		>
			Skip to main content
		</a>
		<!-- eslint-disable -->
		<nav
			class="vn-wrapper"
			:class="{ 'vn-slide-up': hideNav, 'lite': lite, 'no-stick': noStick }"
			:style="getNavBg"
			aria-label="Primary Site Menu"
			itemscope="itemscope"
			itemtype="https://schema.org/SiteNavigationElement"
		>
			<!-- eslint-enable -->
			<div
				class="vn-container hdr-site-1 hdr-site-3"
				:class="{'lite': lite}"
			>
				<button
					@click="toggleMenu()"
					class="vn-menu-btn"
					:style="getNavFg"
					:class="{'vn-close' : menuOpen, 'vn-menu': !menuOpen, 'vn-mt': !lite, 'lite': lite}"
					aria-controls="vn-links"
					id="vn-menu-toggle"
					:aria-label="`${menuOpen ? 'Close Menu' : 'Open Menu'}`"
					:aria-expanded="`${menuOpen || !isMobile ? 'true': 'false'}`"
				>
					<svg
						v-if="!menuOpen"
						xmlns="http://www.w3.org/2000/svg"
						height="36"
						viewBox="0 96 960 960"
						width="36"
					>
						<path
							d="M153.333 816q-14.166 0-23.75-9.617Q120 796.766 120 782.55q0-14.216 9.583-23.716 9.584-9.5 23.75-9.5h653.334q14.166 0 23.75 9.617Q840 768.568 840 782.784q0 14.216-9.583 23.716-9.584 9.5-23.75 9.5H153.333Zm0-206.667q-14.166 0-23.75-9.617Q120 590.099 120 575.883q0-14.216 9.583-23.716 9.584-9.5 23.75-9.5h653.334q14.166 0 23.75 9.617Q840 561.901 840 576.117q0 14.216-9.583 23.716-9.584 9.5-23.75 9.5H153.333Zm0-206.667q-14.166 0-23.75-9.617Q120 383.432 120 369.216q0-14.216 9.583-23.716 9.584-9.5 23.75-9.5h653.334q14.166 0 23.75 9.617Q840 355.234 840 369.45q0 14.216-9.583 23.716-9.584 9.5-23.75 9.5H153.333Z"
						/>
					</svg>
					<svg
						v-else
						xmlns="http://www.w3.org/2000/svg"
						height="36"
						viewBox="0 96 960 960"
						width="36"
					>
						<path
							d="M480 622.666 274.666 828q-9.666 9.667-23.333 9.667-13.666 0-23.333-9.667-9.667-9.667-9.667-23.333 0-13.667 9.667-23.333L433.334 576 228 370.666q-9.667-9.666-9.667-23.333 0-13.666 9.667-23.333 9.667-9.667 23.333-9.667 13.667 0 23.333 9.667L480 529.334 685.334 324q9.666-9.667 23.333-9.667 13.666 0 23.333 9.667 9.667 9.667 9.667 23.333 0 13.667-9.667 23.333L526.666 576 732 781.334q9.667 9.666 9.667 23.333 0 13.666-9.667 23.333-9.667 9.667-23.333 9.667-13.667 0-23.333-9.667L480 622.666Z"
						/>
					</svg>
				</button>
				<div
					class="vn-logo-container"
					:class="{'with-program': programLogo}"
				>
					<a
						:href="getLogoLink"
						class="vn-logo"
						v-metric="{module: 'core', link: 'logo'}"
					>
						<img
							:class="{ 'lite' : lite}"
							:src="getLogo"
							alt="Logo for WebMD"
						/>
					</a>
					<img
						class="vn-logo-div"
						v-if="lite && programLogo"
						src="./assets/divider.svg"
					/>
					<a
						v-if="lite && programLogo"
						:href="programLink"
						class="vn-prog-logo"
						v-metric="{module: 'core', link: 'prog_logo'}"
					>
						<img
							:src="programLogo"
							alt=""
						/>
					</a>
				</div>
				<div
					class="vn-menu-mask"
					:class="{ active: menuOpen }"
					@click="toggleMenu()"
				></div>
				<div
					class="vn-links"
					:class="{'open': menuOpen, 'vn-slide-out': navData.filter(n => n.open).length > 0,
						'lite': lite }"
					aria-labelledby="vn-menu-toggle"
					id="vn-links"
				>
					<ul
						class="vn-links-list"
						:class="{ 'lite': lite }"
					>
						<li
							v-metric="{module: 'core'}"
							:class="{'vn-mt': !lite }"
						>
							<a
								v-metric="{link: 'home'}"
								href="https://www.webmd.com"
							>
								Home
							</a>
						</li>
						<li
							v-for="(group, $index) in navData"
							:key="$index"
							v-metric="{module: `${metricsModule}-${$index + 1}`}"
							:class="[{ 'vn-link': !getSectionLinks(group)}]"
							@mouseover="handleMouseover(getSectionLinks(group),group)"
							@mouseleave="handleMouseover(getSectionLinks(group), group,true)"
							:tabindex="`${getSectionLinks(group) ? '0' : ''}`"
						>
							<a
								v-if="getSectionLinks(group)"
								@click="toggleGroup(group)"
								v-metric="{link: '0', type: 'ad-hoc'}"
								:id="`vn-link-${metricsModule}-${$index + 1}`"
								:aria-controls="`vn-menu-${metricsModule}-${$index + 1}`"
								:aria-expanded="`${group.open ? 'true': 'false'}`"
								:aria-label="group.group_name"
							>
								{{ group.group_name }}
								<i
									class="webmd-icon-right-arrow"
									:class="{'vn-mt': !lite }"
									v-if="getSectionLinks(group)"
								></i>
								<i
									class="webmd-icon-down-arrow vn-dt"
									:class="{'vn-none': lite }"
									v-if="getSectionLinks(group)"
								></i>
							</a>
							<a
								:href="group.group_link_url"
								v-metric="{link: '0'}"
								v-else
							>
								{{ group.group_name }}
							</a>

							<div
								:class="['vn-menu-section', `${metricsModule}-${$index + 1}`,
									{'open': group.open, 'lite': lite} ]"
								v-if="getSectionLinks(group)"
								:id="`vn-menu-${metricsModule}-${$index + 1}`"
								:aria-labelledby="`vn-link-${metricsModule}-${$index + 1}`"
							>
								<button
									@click="toggleGroup(group)"
									class="vn-back"
									:class="{'vn-mt': !lite }"
									v-metric="{link: 'back', type: 'ad-hoc'}"
								>
									<i class="webmd-icon-left-arrow"></i>
									Back
								</button>
								<header
									class="vn-menu-section-header"
									:class="{'vn-mt': !lite }"
								>
									<span class="nav-title">{{ group.group_name }}</span>
									<a
										:href="group.group_link_url"
										v-if="group.group_link_url !== ''"
										v-metric="{link: 'all'}"
									>
										<img
											src="./assets/arrow-right.svg"
											alt=""
										/>
										View All
									</a>
								</header>
								<ul :v-if="isMobile ? renderList && clickedGroup === group : true">
									<li
										v-for="(link, $indexB) in getSectionLinks(group)"
										:key="$indexB"
										itemprop="name"
									>
										<a
											:href="link.link_friendlyUrl"
											v-metric="{link: $indexB + 1}"
											itemprop="url"
										>
											{{ link.link_text }}
										</a>
									</li>
									<li
										class="vn-see-all vn-dt"
										:class="{'vn-none' : lite }"
										v-if="group.group_link_url !== ''"
									>
										<a
											:href="group.group_link_url"
											v-metric="{link: 'all'}"
										>
											<img
												alt=""
												src="./assets/arrow-right.svg"
											/>
											View All
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li
							v-if="!lite"
							v-metric="{module: `${metricsModule}-7`}"
							:class="{'vn-mt': !lite }"
						>
							<a
								@click="toggleFooter()"
								v-metric="{link: '0', type: 'ad-hoc'}"
							>
								Privacy & More

								<i
									class="webmd-icon-right-arrow"
								></i>
							</a>
						</li>
					</ul>
					<div
						class="vn-actions"
						:class="{ 'lite': lite, 'no-subscribe': hideSubscribe }"
					>
						<WebmdNewsletter
							v-if = "!hideSubscribe"
							location="overlay"
							class="vn-subscribe"
							:class="{'vn-trans': searchOpen, 'lite': lite}"
						/>
						<a
							v-if="loggedIn"
							class="vn-loggedin"
							:class="{'vn-trans': searchOpen, 'lite': lite}"
							:href="profileUrl"
							v-metric="{module: 'profile'}"
						>
							My Profile
						</a>
						<a
							v-else
							class="vn-signin"
							:class="{'vn-trans': searchOpen, 'lite': lite}"
							:href="signInUrl"
							v-metric="{module: 'reg-login'}"
						>
							Log In
						</a>

						<button
							class="vn-menu-btn vn-search vn-dt"
							:class="{'vn-close': searchOpen, 'vn-none' : lite, 'lite': lite }"
							@click="toggleSearch()"
							aria-label="Search"
						>
							<svg
								v-if="!searchOpen"
								xmlns="http://www.w3.org/2000/svg"
								height="30"
								viewBox="0 96 960 960"
								width="30"
							>
								<path
									d="M768 911.333 532.667 676q-30 25.333-69.64 39.667Q423.388 730 378.667 730q-108.441 0-183.554-75.167Q120 579.667 120 472.667T195.167 290.5q75.166-75.167 182.5-75.167 107.333 0 182.166 75.167 74.834 75.167 74.834 182.267 0 43.233-14 82.9-14 39.666-40.667 73l237 235.667q9.667 9.294 9.667 22.814 0 13.519-10.609 24.127Q806.333 921 791.852 921T768 911.333ZM378 663.334q79.167 0 134.583-55.834Q568 551.667 568 472.667q0-79.001-55.417-134.834Q457.167 282 378 282q-79.722 0-135.528 55.833t-55.806 134.834q0 79 55.806 134.833Q298.278 663.334 378 663.334Z"
								/>
							</svg>
							<svg
								v-else
								xmlns="http://www.w3.org/2000/svg"
								height="30"
								viewBox="0 96 960 960"
								width="30"
							>
								<path
									d="M480 622.666 274.666 828q-9.666 9.667-23.333 9.667-13.666 0-23.333-9.667-9.667-9.667-9.667-23.333 0-13.667 9.667-23.333L433.334 576 228 370.666q-9.667-9.666-9.667-23.333 0-13.666 9.667-23.333 9.667-9.667 23.333-9.667 13.667 0 23.333 9.667L480 529.334 685.334 324q9.666-9.667 23.333-9.667 13.666 0 23.333 9.667 9.667 9.667 9.667 23.333 0 13.667-9.667 23.333L526.666 576 732 781.334q9.667 9.666 9.667 23.333 0 13.666-9.667 23.333-9.667 9.667-23.333 9.667-13.667 0-23.333-9.667L480 622.666Z"
								/>
							</svg>
						</button>
					</div>
					<form
						class="vn-search-wrapper"
						:class="{'vn-open': searchOpen, 'lite': lite }"
						ref="searchForm"
						:action="formAction"
						@submit.prevent="doSearch"
					>
					<WebmdInput
						name="query"
						ref="searchInput"
						v-model="searchTerm"
						type="text"
						size="medium"
						placeholder="Ask WebMD"
						:autocomplete="'off'"
						class="vn-search-input"
						required
					/>

						<button
							type="submit"
							:class="{ 'lite': lite }"
						>
							Search
						</button>
					</form>
				</div>
				<WebmdNewsletter
					v-if="!lite && !hideSubscribe"
					location="overlay"
					class="vn-subscribe vn-mt vn-mob-gn-sub"
					:class="{'vn-hidden': menuOpen}"
				/>
				<button
					class="vn-menu-btn vn-search"
					@click="toggleMenu(true)"
					:style="getNavFg"
					:class="{'vn-hidden': menuOpen, 'vn-mt': !lite, 'lite': lite }"
					aria-label="Search"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						height="30"
						viewBox="0 96 960 960"
						width="30"
					>
						<path
							d="M768 911.333 532.667 676q-30 25.333-69.64 39.667Q423.388 730 378.667 730q-108.441 0-183.554-75.167Q120 579.667 120 472.667T195.167 290.5q75.166-75.167 182.5-75.167 107.333 0 182.166 75.167 74.834 75.167 74.834 182.267 0 43.233-14 82.9-14 39.666-40.667 73l237 235.667q9.667 9.294 9.667 22.814 0 13.519-10.609 24.127Q806.333 921 791.852 921T768 911.333ZM378 663.334q79.167 0 134.583-55.834Q568 551.667 568 472.667q0-79.001-55.417-134.834Q457.167 282 378 282q-79.722 0-135.528 55.833t-55.806 134.834q0 79 55.806 134.833Q298.278 663.334 378 663.334Z"
						/>
					</svg>
				</button>
			</div>
			<SetRendered
				:chronic-id="chronicId"
				:data="getModuleData"
			/>
		</nav>
		<component
			:is="'style'"
			v-if="noStick"
		>
			html body {
			margin-top: 0;
			}
		</component>
	</div>
</template>

<script>

// eslint-disable-next-line import/extensions,import/no-unresolved
import useStore from 'webmd-cms-store/src/store';

import _has from 'lodash/has';
import _indexOf from 'lodash/indexOf';
import _find from 'lodash/find';
import WebmdNewsletter from 'webmd-newsletter/src/Component.vue';
import { Input } from 'webmd-elements';
import url from 'url';
import cookie from 'webmd-cookie';
import { getType } from 'webmd-useragent';
import emitter from 'tiny-emitter/instance';
import SetRendered from './components/SetRendered.vue';
import throttle from 'lodash/throttle';

export default {
	name: 'WebmdVueHeader',
	data() {
		return {
			menuOpen: false,
			metricsModule: 'hdr-site',
			navData: [],
			searchTerm: '',
			isMobile: true,
			searchOpen: false,
			loggedIn: false,
			stickyAdReferences: ['definition', 'biography', 'medical reference', 'news', 'feature', 'tool - slide show', 'podcast', 'tool - rmq', 'feature - video', 'product a-z', 'toc - program', 'toc - topic dir', 'toc - guide chapter'],
			hideNav: false,
			isSmallTablet: false,
			has101StickyAd: false,
			isOpen: false,
			renderList: false,
			clickedGroup: null,
			hideSubscribe: false,
		};
	},

	props: {
		chronicId: {
			type: String,
		},
		lite: {
			type: Boolean,
			default: false,
		},
		noStick: {
			type: Boolean,
			default: false,
		},
		logo: {
			type: String,
			default: 'https://img.wbmdstatic.com/vim/live/webmd/consumer_assets/site_images/logos/webmd/web/webmd_logo_white.svg',
		},
		logoLink: {
			type: String,
			default: 'https://www.webmd.com/',
		},
		programLogo: {
			type: String,
			default: null,
		},
		programLink: {
			type: String,
			default: null,
		},
		background: {
			type: String,
			default: '#113551',
		},
		foreground: {
			type: String,
			default: '#ffffff',
		},
		noStickyBanner: {
			type: Boolean,
			default: false,
		},
	},

	components: {
		WebmdNewsletter,
		WebmdInput: Input,
		SetRendered,
	},

	created() {
		this.store = useStore(this.$pinia);
		if(this.store?.pagedata?.omniture?.s_cap_id === '091e9c5e8266cd23') {
			this.hideSubscribe = true;
		}
		this.moduleData = this.getModuleData;
		this.navData = this.getNavData;
	},

	mounted() {
		const self = this;
		this.isMobile = window.matchMedia('(max-width: 1024px)').matches || self.lite;
		this.isSmallTablet = window.screen.width >= 768 && window.screen.width < 1025;
		this.isNewTabSpec = window.screen.width > 767 && window.screen.width < 1025 && !(this.$route?.query?.ecd && this.$route?.query?.ecd.includes('conmkt'));
		const busref = window?.s_business_reference?.toLowerCase();
		const validBusrefs = ['feature', 'news', 'medical reference', 'tool - slide show', 'tool - rmq'];
		const isAdApplicable = validBusrefs.includes(busref);

		this.$el.classList.add('vn-scrim');

		if (self.lite) {
			this.$el.classList.add('lite')
		}

		// Check logged in store for future use
		if (cookie.get('WBMD_AUTH')) {
			this.loggedIn = true;
		}

		emitter.on('check-log-in', (event) => {
			this.loggedIn = true;
		});

		// Watch scroll position
		if (!self.noStick) {
			this.handleThrottleScroll = throttle(this.onScroll,100);
			window.addEventListener('scroll', this.handleThrottleScroll, { passive: true } );
		}

		if (window.matchMedia('(max-width: 466px)').matches && !this.noStickyBanner && window.s_business_reference !== 'Appointment Prep' && !isAdApplicable) {
		 	window.document.addEventListener('onAdobeOmniAfterPv', () => {
		 		const pageNum = window.adobeDataLayer ? window.adobeDataLayer.getState('page.pagination') : window?.s_md?.prop9;
		 		const adId = 'ad-pos-2025-1';
		 		const articleLength = window?.infiniteList ? Object.keys(window.infiniteList).length : 1;
		 		const pgParam = `${pageNum}-${articleLength}`;
		 		// eslint-disable-next-line no-unused-expressions
		 		window?.webmd?.ads?.setPageTarget('pg', pgParam);
		 		if ((parseInt(pageNum, 10) > 1) && window.webmd?.ads?.ads[adId]) {
		 			window.webmd.ads.refresh({ id: adId });
		 		}
		 	});
		}

		if (!this.noStickyBanner && typeof window.s_business_reference === 'string'
			&& _indexOf(this.stickyAdReferences, window.s_business_reference.toLowerCase()) > -1) {
			let attempts = 0;
			const waitUntilAdAppears = setInterval(() => {
				// eslint-disable-next-line no-plusplus
				if (++attempts > 20) {
					clearInterval(waitUntilAdAppears);
				}
				if (typeof window.googletag !== 'undefined' && window.googletag.pubads) {
					let slot = '';
					if (getType() === 'desktop' || getType() === 'tablet') {
						slot = document.getElementById('ad-pos-101-1');
					}
					if (getType() === 'mobile') {
						slot = document.getElementById('ad-pos-2025-1');
					}

					window.googletag.pubads().addEventListener('slotRenderEnded', (event) => {
						if (event && !event.Empty && slot && event.slot.getSlotElementId() === slot.id) {
							emitter.on('bannerAdSticky-webmd-sticky-floor-reached', () => {
								try {
									self.bannerAdSticky.end();
									// eslint-disable-next-line no-empty
								} catch (e) {
								}
							});
							emitter.on('bannerAdSticky-webmd-sticky-createblank', ($el) => {
								const [headerAdsDivCount] = $el;
								window.headerAds = headerAdsDivCount;

								/*
								 * Timeout of 7 seconds to unstick top ad in mobile
								 * Don't unstick if we are in mobile slideshow page
								 */

								if (getType() === 'mobile' && window.s_business_reference.toLowerCase() !== 'tool - slide show') {
									setTimeout(() => {
										self.bannerAdSticky.end();
									}, 7000);
								}
							});
							emitter.on('leftRailAdSticky-webmd-sticky-createblank', ($el) => {
								const [leftSideAdsDivCount] = $el;
								window.leftRailAdSticky = leftSideAdsDivCount;
							});

							if (getType() === 'desktop' || !this.isNewTabSpec) {
								const topAd = document.querySelector('.ad-101');
								const topStickyCreated = topAd ? topAd.classList.contains('is-fixed') : null;

								if (topAd && !topStickyCreated) {
									self.sticky({
										element: '.ad-101',
										name: 'bannerAdSticky',
										css: {
											marginTop: '0px',
											top: '0px',
											width: '100%',
											zIndex: '99999',
											background: '#ffffff',
										},
										ceiling: true,
										startOnTouch: false,
										floor: 1200,
										className: 'is-fixed',
									});
								}
								//checking if 101 sticky ad is created
								this.has101StickyAd = topAd ? topAd.classList.contains('is-fixed') : false;
							}

							if (getType() === 'desktop' || getType() === 'tablet') {
								const leftAd = document.getElementById('ad-pos-113-1');
								const leftStickyCreated = leftAd ? leftAd.classList.contains('is-fixed') : null;

								if (leftAd && !leftStickyCreated) {
									self.sticky({
										element: '.ad-113',
										name: 'leftRailAdSticky',
										css: {
											top: '132px',
											margin: '20px auto 0',
											left: 'inherit',
											zIndex: '9999',
										},
										ceiling: 'ContentPane25',
										startOnTouch: false,
										floor: 'ContentPane47',
										className: 'is-fixed',
									});
								}
							}
						}
					});

					clearInterval(waitUntilAdAppears);
				}
			}, 200);
		}
	},

	computed: {
		getModuleData() {
			return this.store.cms.getModules(this.chronicId);
		},
		getNavData() {
			const module = this.moduleData;
			let nav;

			if (_has(module, 'module_data.shared_Modules.SharedModules')) {
				nav = _find(module.module_data.shared_Modules.SharedModules, ['module_settings.title', 'hicbn']);

				if (nav) {
					return nav.module_data.groups.group.map((g) => ({ ...g, open: false }));
				}
			}

			return [];
		},

		signInUrl() {
			const canonical = this.store.pagedata.meta.canonicalurl || 'https://www.webmd.com';
			const url = canonical.includes('staging') ? 'https://member.staging.webmd.com/signin' : 'https://member.webmd.com/signin';
			return `${url}?appid=1&returl=${canonical}`;
		},

		profileUrl() {
			const canonical = this.store.pagedata.meta.canonicalurl || 'https://www.webmd.com';
			const url = canonical.includes('staging') ? 'https://member.staging.webmd.com/profile' : 'https://member.webmd.com/profile';
			return url;
		},

		formAction() {
			let canonical = this.store.pagedata.meta.canonicalurl || 'https://www.webmd.com';
			canonical = url.parse(canonical);

			return `https://${canonical.hostname}/search/search_results/default.aspx`;
		},

		getNavBg() {
			let style = {};

			if (this.lite) {
				style = {
					'background-color': this.background,
				};
			}

			return style;
		},

		getNavFg() {
			return this.lite ? {
				color: this.foreground,
			} : {};
		},

		getLogo() {
			return this.logo;
		},

		getLogoLink() {
			return this.logoLink;
		},
	},

	methods: {
		toggleMenu(fromSearch) {
			this.menuOpen = !this.menuOpen;
			if (this.menuOpen) {
				this.$vwmdPageLink({ moduleName: 'mnu-open' });
				setTimeout(() => {
					document.body.style.overflow = 'hidden';
					this.blur();
					if (fromSearch) {
						this.$refs.searchInput.$refs.input.focus();
					}
				}, 0);
			} else {

				this.$vwmdPageLink({ moduleName: 'mnu-cls' });
				setTimeout(() => {
					document.body.style.overflow = '';
					this.clearSearch();
					this.blur(true);
					// eslint-disable-next-line no-param-reassign,no-return-assign
					this.navData.forEach((n) => n.open = false);
				}, 0);
			}
		},

		toggleGroup(group) {
			this.renderList = !this.renderList;
			this.clickedGroup = group;
			if (!this.isMobile) {
				return;
			}
			// eslint-disable-next-line max-len
			this.navData.find((n) => n.group_name === group.group_name).open = !this.navData.find((n) => n.group_name === group.group_name).open;
		},

		getSectionLinks(group) {
			const links = group.link_items.link_item.filter((l) => l.link_friendlyUrl !== '');

			if (links.length > 0) {
				return links;
			}

			return false;
		},

		doSearch() {
			
			this.$vwmdTrack({ moduleName: 'srch-bar_submit' });
			this.$refs.searchForm.submit();
		},

		clearSearch() {
			this.searchTerm = '';
		},

		blur(unblur) {
			this.isOpen = true;
			
			if (unblur) {
				this.isOpen = false;
			}
		},

		toggleFooter() {
			const event = new Event('webmd.footer.overlay.open');
			document.dispatchEvent(event);
		},

		handleMouseover(items, group, mouseleave) {
			if (!this.isMobile && items) {
				if (!mouseleave) {
					this.blur();
					// eslint-disable-next-line no-param-reassign
					group.open = true;
				} else {
					this.blur(true);
					// eslint-disable-next-line no-param-reassign
					group.open = false;
				}
			}
		},

		toggleSearch() {
			const self = this;

			self.searchOpen = !self.searchOpen;

			if (!self.searchOpen) {
				self.clearSearch();
			} else {
				setTimeout(() => {
					self.$refs.searchInput.$refs.input.focus();
				}, 300);
			}
		},

		onScroll() {
			//To hide nav on small tablet while 101 ad is visible
			if(this.isSmallTablet && this.has101StickyAd && window.pageYOffset  < 1200 && window.pageYOffset > 50)
			{
				this.hideNav = true;
				return;	
			}

			if (this.$route && this.$route.query && this.$route.query.ecd && this.$route.query.ecd.includes('conmkt')) {
				if(this.store.pagedata.omniture.s_business_reference.toLowerCase() === 'tool - slide show') {
					if (this.isSmallTablet && window.pageYOffset > 50) {
						this.hideNav = true;
						return;
					}
				}
			}
			
			// Because of momentum scrolling on mobiles, adding minimum offset value
			if (window.pageYOffset < 200 || !this.isMobile) {
				this.hideNav = false;
				return;
			}
			this.hideNav = window.pageYOffset > this.lastScrollPosition;
			this.lastScrollPosition = window.pageYOffset;
			if (!this.hideNav) {
				const navVisb = new Event('webmd.globalnav.visible');
				document.dispatchEvent(navVisb);
			} else {
				const navHidden = new Event('webmd.globalnav.hidden');
				document.dispatchEvent(navHidden);
			}
		},

	},
};
</script>

<style lang="scss">
$sans: "Source Sans Pro", Arial, sans-serif;
$carbon: #1b1b1b;
$imperial: #00157c;
$ultramarine: #3557ff;
$lavender: #CCCCE7;
$white: #ffffff;
$overlay: rgba($white, 0.8);
$menu-bg: #F9F9FC;
$rule: #C6CEDB;
$grey-text: #7F888F;
$grey-bg-color: #f7f7f7;
$grey-label-color: #6b6b6b;
$ghost: #F8F8F8;

$mobile: px2rem(600);
$tablet: px2rem(768);
$desktop: px2rem(1025);
$max-width: px2rem(1300);

.vn-scrim {
		&::before {
			background: $overlay;
			content: '';
			height: 100%;
			left: 0;
			opacity: 0;
			position: fixed;
			top: 0;
			width: 100%;
			visibility: hidden;
			z-index: 100000;
			transition: 0.4s ease all;

			@media(min-width: $desktop) {
				transition-delay: 0.2s;
			}
		}

		&.vn-open {
			&::before {
				opacity: 1;
				visibility: visible;
				transition-delay: 0s;

				:not(.lite) {
					@media(min-width: $desktop) {
						visibility: hidden;
					}
				}
			}
		}
	}

html body  {
	margin-top: px2rem(48);
	padding-top: 0;
	-webkit-font-smoothing: antialiased;

	@media (max-width: $mobile) {
		main {
			margin-top: 1rem;
		}
	}

	@media(min-width: $desktop) {
		margin-top: 0;
	}

}

html.class-bg-ghost {
	background: $ghost;
}

.vn-typeahead-suggestions {
	background: #fff;
	border-radius: 5px;
	box-shadow: none;
	left: 0 !important;
	margin: 0 8px !important;
	height: px2rem(398);
	overflow: hidden;
	top: 6.875rem !important;
	width: calc(100% - 1rem);

	.webmd-autocomplete-suggestion__wrap {
		border: 0;
		border-radius: 0;
	}

	&.lite {
		@media(min-width: $desktop) {
			top: px2rem(138) !important;
		}
	}

	@media (min-width: $mobile) {
		max-width: calc(400px - 1rem) !important;
	}
}

.webmd-autocomplete-suggestion {
	z-index: 1000000 !important;
}

.vn-skip-to-main {
	background: $white;
	border-radius: 0 0 5px 5px;
	color: $carbon;
	display: block;
	height: px2rem(30);
	padding: 0.3rem;
	margin: 0 0.5rem;
	position: fixed;
	text-decoration: none;
	top: -100px;
	transition: 0.3s top ease;
	z-index: 100001;

	&:focus {
		top: 0;
	}
}

.vn-wrapper {
	background: $imperial;
	box-sizing: border-box;
	font-family: $sans;
	position: fixed;
	top: 0;
	transition: 0.5s transform ease;
	width: 100%;
	z-index: 100000;

	&.lite {
		@media (min-width: $desktop) {
			padding: 0 1.5rem;
		}
	}

	&.no-stick {
		position: relative;
	}

	* {
		box-sizing: border-box;
		font-family: $sans;
		letter-spacing: normal;
	}

	&.vn-slide-up {
		transform: translateY(-100%);
	}

	@media(min-width: $desktop) {
		position: relative;
	}

	@media(max-width: $max-width) {
		padding: 0 1rem;
	}

	.vn-dt {
		display: none !important;

		@media(min-width: $desktop) {
			display: block !important;
		}
	}

	.vn-mb {
		display: block;

		@media(min-width: $tablet) {
			display: none !important;
		}
	}

	.vn-tb {
		display: none;

		@media(min-width: $tablet) {
			display: block;
		}
	}

	.vn-mt {
		display: block;

		@media(min-width: $desktop) {
			display: none !important;
		}
	}

	.vn-hidden {
		visibility: hidden !important;
	}

	.vn-trans {
		opacity: 0;
	}

	.vn-none {
		display: none !important;

		@media(min-width: $desktop) {
			display: none !important;
		}
	}

	.vn-container {
		align-items: center;
		display: flex;
		justify-content: space-between;
		height: px2rem(48);
		margin: 0 auto;
		max-width: px2rem(1240);
		z-index: 1;

		@media (min-width: $desktop) {
			height: px2rem(75);
		}

		&.lite {
			max-width: 100%;

			@media (min-width: $desktop) {
				height: px2rem(56);
			}
		}
	}

	.vn-menu-btn {
		align-items: center;
		background: none;
		border: 0;
		color: $white;
		cursor: pointer;
		display: flex;
		height: 100%;
		line-height: 1;
		padding: 0;

		&:not(.lite) {
			margin-right: px2rem(18.67);
			@media (min-width: $desktop) {
				margin-right: 0;
			}
		}

		i {
			font-size: px2rem(36);
			width: px2rem(36);
			overflow: hidden;
		}

		svg {
			fill: currentColor;
			pointer-events: none;
		}

		&.vn-search {
			i {
				font-size: px2rem(30);
				width: px2rem(30);
			}

			&:not(.lite) {
				margin-right: 0;
				@media (min-width: $desktop) {
					i {
						font-size: px2rem(26);
						width: px2rem(26);
					}
				}
			}

			&.lite {
				i {
					font-size: px2rem(32);
					width: px2rem(32);
				}
			}
		}
	}

	.vn-logo-container {
		align-items: center;
		display: flex;

		.vn-logo-div {
			height: px2rem(15);
			margin: 0 px2rem(10);

			@media (min-width: $desktop) {
				height: px2rem(25);
				margin: 0 px2rem(20);
			}
		}

		.vn-logo,
		.vn-prog-logo {
			line-height: 1;

			img {
				display: block;
				height: px2rem(21);

				@media (min-width: $desktop) {
					height: px2rem(26);
				}
			}
		}

		.vn-logo img:not(.lite) {
			@media (min-width: $desktop) {
				width: px2rem(116);
			}
		}

		&.with-program {
			.vn-logo {
				img {
					height: px2rem(14);

					@media (min-width: $desktop) {
						height: px2rem(23);
					}
				}
			}

			.vn-prog-logo {
				img {
					height: px2rem(15);

					@media (min-width: $desktop) {
						height: px2rem(25);
					}
				}
			}
		}
	}

	.vn-links {
		background: $menu-bg;
		display: flex;
		flex-direction: column;
		height: calc(100vh - #{px2rem(48)});
		left: -140vw;
		overflow: auto;
		padding: px2rem(8);
		position: fixed;
		top: px2rem(48);
		transition: 0.5s ease left;
		width: 100%;
		z-index: 100;

		@media (min-width: $mobile) {
			max-width: px2rem(400);
		}

		&.lite {
			@media (min-width: $desktop) {
				height: calc(100vh - #{px2rem(56)});
				top: px2rem(56);
			}
		}

		&:not(.lite) {
			@media (min-width: $desktop) {
				background: none;
				flex-direction: row;
				height: 100%;
				left: 0;
				max-width: 100%;
				overflow: visible;
				padding: 0;
				position: relative;
				top: 0;
			}
		}

		&.open {
			left: 0;

			&.vn-slide-out {
				left: -100vw;

				@media (min-width: $mobile) {
					left: 0;
				}
			}
		}

		.vn-search-wrapper {
			display: flex;
			height: px2rem(48);
			margin-bottom: px2rem(4);
			order: -1;

			&:not(.lite) {
				@media(min-width: $desktop) {
					background: $white;
					border: 1px solid $rule;
					border-radius: 5px;
					opacity: 0;
					order: 1;
					position: absolute;
					right: px2rem(45);
					top: px2rem(13);
					width: 38%;
					transition: 0.3s all ease;
					visibility: hidden;

					&.vn-open {
						visibility: visible;
						opacity: 1;
					}

					input {
						border: 0;
						height: px2rem(45);
					}
				}
			}

			& > div {
				flex-grow: 1;

				& > div {
					width: 100%;
				}
			}

			input {
				border: $lavender 1px solid;
				border-right: 0;
				border-radius: 5px 0 0 5px;
				flex-grow: 1;
				font-size: px2rem(18);
				height: px2rem(48);
				padding: 0 px2rem(22);

				&::placeholder {
					color: $grey-text;
				}
			}

			button {
				background: $ultramarine;
				border: 0;
				border-radius: 0 5px 5px 0;
				color: $white;
				cursor: pointer;
				font-size: 1rem;
				font-weight: 600;
				height: px2rem(48);
				padding: 0 px2rem(12);

				&:not(.lite) {
					@media(min-width: $desktop) {
						border-radius: 5px;
						font-weight: 400;
						height: px2rem(38);
						margin: px2rem(4);
					}
				}
			}
		}

		.vn-links-list {
			list-style: none;
			margin: 0;
			padding: 0;

			& > li {
				background: $white;
				border-radius: px2rem(5);
				font-weight: 700;
				height: px2rem(48);
				margin-top: px2rem(2);

				a {
					align-items: center;
					color: $carbon;
					cursor: pointer;
					display: flex;
					justify-content: space-between;
					height: 100%;
					padding: 0 px2rem(18) 0 px2rem(15);
					text-decoration: none;

					.webmd-icon-right-arrow {
						color: $ultramarine;
					}
				}
			}

			&:not(.lite) {
				@media (min-width: $desktop) {
					align-items: center;
					display: flex;
					flex-grow: 1;
					justify-content: space-between;
					padding: 0 px2rem(16) 0 px2rem(14);

					& > li {
						align-items: center;
						background: none;
						display: flex;
						height: 100%;
						margin-right: 0;
						margin-top: px2rem(0);
						position: relative;

						&.vn-link {
							text-align: center;
							transition: 0.3s all ease;
						}

						> a {
							border-radius: 5px;
							color: $white;
							cursor: pointer;
							font-size: px2rem(17);
							font-weight: 600;
							height: auto;
							padding: px2rem(8) px2rem(10);

							span {
								text-align: center;
							}

							i {
								font-size: px2rem(10);
								margin-left: px2rem(5);
								transition: 0.3s transform ease;
							}
						}

						&:hover {
							& > a {
								background: $white;
								color: $imperial;

								i {
									transform: rotate(180deg);
								}
							}

							.vn-menu-section {
								left: 0;
								opacity: 1;
								visibility: visible;
							}
						}

						&:focus-visible, &:has(:focus-visible) {
							& > a {
								background: $white;
								color: $carbon;

								i {
									transform: rotateX(180deg);
								}
							}

							.vn-menu-section {
								left: 0;
								opacity: 1;
								visibility: visible;
							}
						}
					}
				}
			}

			&:not(.lite) {
				@media (min-width: $max-width) {
					& > li:not(:nth-child(7)) {
						margin-right: 1rem;
					}
				}
			}
		}

		.vn-menu-section {
			background: $menu-bg;
			height: calc(100vh - #{px2rem(48)});
			right: -140vw;
			overflow: auto;
			padding: 0 px2rem(24) px2rem(100) px2rem(24);
			position: fixed;
			top: px2rem(48);
			transition: 0.5s ease all;
			width: 100%;
			z-index: 10;

			&.lite {
				height: calc(100vh - #{px2rem(56)});
				top: px2rem(56);
			}

			@media (min-width: $mobile) {
				max-width: px2rem(400);
				left: -140vw;
				right: auto;

				&.open {
					left: 0;
					right: auto;
				}
			}

			&.open {
				right: 0;
			}

			.vn-menu-section-header {
				align-items: center;
				border-bottom: 1px solid $rule;
				display: flex;
				justify-content: space-between;
				padding: px2rem(12) 0;

				.nav-title {
					color: $carbon;
					font-size: px2rem(20);
					line-height: 1;
					margin: 0;
				}

				a {
					color: $ultramarine;
					font-weight: normal;
					text-decoration: none;

					img {
						margin-right: px2rem(8);
						width: px2rem(13);
					}
				}
			}

			ul {
				margin: px2rem(12) 0;
				list-style: none;
				padding: 0;

				li {
					font-size: px2rem(18);
					font-weight: normal;

					a {
						color: $carbon;
						display: block;
						padding: px2rem(12) 0;
						text-decoration: none;

						&:hover {
							color: $ultramarine;
						}
					}

					hr {
						border: 1px solid $rule;
					}
				}
			}

			&:not(.lite) {
				@media (min-width: $desktop) {
					background: $white;
					border-radius: 0 0 5px 5px;
					border-top: 0;
					left: -20px;
					margin-left: px2rem(-60);
					max-width: none;
					height: auto;
					opacity: 0;
					padding: px2rem(30) px2rem(46);
					position: absolute;
					top: px2rem(75);
					width: px2rem(300);
					visibility: hidden;

					hr {
						display: none;
					}

					ul {
						margin: 0;

						li {
							border-bottom: 1px solid $rule;

							&:last-of-type {
								border-bottom: 0;
							}

							&.vn-see-all {
								a {
									align-items: baseline;
									color: $ultramarine;
									display: flex;
									justify-content: flex-start;

									img {
										height: px2rem(12);
										margin-right: px2rem(8);
									}
								}
							}
						}
					}

					&.hdr-site-1 {
						width: calc(#{$desktop} - #{px2rem(50)});

						ul {
							columns: 4;
							column-gap: px2rem(46);

							li {
								&:nth-child(7), &:nth-child(14), &:nth-child(21) {
									border-bottom: 0;
								}
							}
						}
					}

					&.hdr-site-3 {
						width: px2rem(560);

						ul {
							columns: 2;
							column-gap: px2rem(46);

							li {
								&:nth-child(8), &:nth-child(16) {
									border-bottom: 0;
								}
							}
						}
					}
				}

				@media (min-width: $desktop) and (max-width: $max-width) {
					&.hdr-site-1 {
						margin-left: px2rem(-140);
					}
				}
			}
		}

		.vn-back {
			align-items: center;
			background: none;
			border: 0;
			color: $ultramarine;
			cursor: pointer;
			display: flex;
			padding: 1rem 0;

			i {
				font-size: px2rem(12);
				margin-right: px2rem(5);
			}
		}

		.vn-actions {
			margin-top: 1rem;

			&:not(.lite) {
				@media(min-width: $desktop) {
					align-items: center;
					border-left: 1px solid $lavender;
					display: flex;
					margin: px2rem(19) 0;
					padding-left: px2rem(20);
				}
				&.no-subscribe {
					@media(min-width: $desktop) {
						border-left: none;
					}
					.vn-signin {
						padding-left: .9375rem;
						@media(min-width: $desktop) {
							padding-left: 0;
						}
					}
				}
			}

			.vn-signin {
				color: $ultramarine;
				font-weight: 600;
				padding: 0 px2rem(24);
				text-decoration: none;

				&:not(.lite) {
					@media(min-width: $desktop) {
						align-items: center;
						color: $white;
						display: flex;
						font-size: px2rem(17);
						padding: 0;
						margin: 0 px2rem(15);
						transition: 0.3s all ease;
					}
				}
			}

			.vn-loggedin {
				background: none;
				border: 0;
				color: $ultramarine;
				font-weight: 600;
				height: px2rem(48);
				padding: 0 px2rem(24);
				text-decoration: none;

				&:not(.lite) {
					@media(min-width: $desktop) {
						align-items: center;
						color: $white;
						display: flex;
						font-size: 0;
						padding: 0;
						margin: 0 px2rem(20);

						&::before {
							background: url('./assets/person.svg') no-repeat;
							background-size: contain;
							content: '';
							display: block;
							height: px2rem(26);
							width: px2rem(26);
						}
					}
				}
			}

		}
	}

	.vn-subscribe {
		display: inline-block;
		padding-top: 0;

		& > button {
			background: none;
			border: 1px solid $ultramarine;
			border-radius: 5px;
			color: $ultramarine;
			font-size: 1rem;
			font-weight: 600;
			padding: px2rem(8) px2rem(10) px2rem(8) px2rem(11.67);

			&:focus-visible {
				outline: 2px solid $white;
				outline-offset: 3px;
			}

			&::before {
				background: url('./assets/mobile-mail.svg') no-repeat;
				background-size: contain;
				content: "";
				display: inline-block;
				height: px2rem(13.33);
				margin-right: px2rem(4);
				vertical-align: bottom;
				width: px2rem(16.67);
			}

		}

		.webmd-dialog__wrapper {
			background: $overlay
		}

		&:not(.lite) {
			@media(min-width: $desktop) {
				transition: 0.3s all ease;

				& > button {
					border-color: $lavender;
					color: $white;

					&:hover {
						background-color: $white;
						color: $imperial;
						transition: 0.3s all ease;

						&:before {
							background: url('./assets/mail-navblue.svg') no-repeat;
						}
					}

					&::before {
						background: url('./assets/mail.svg') no-repeat;
					}
				}
			}
		}

		&.vn-mob-gn-sub {
			margin-left: auto;
			margin-right: px2rem(12);

			& > button {
				border: none;
				border-radius: 0;
				border-right: 1px solid $rule;
				color: $white;
				font-size: px2rem(14);
				font-weight: 600;

				&::before {
					background: url('./assets/mail.svg') no-repeat;
					background-size: px2rem(13);
					height: px2rem(10.67);
					width: px2rem(13.33);
				}
			}
		}
	}
}

.vn-menu-mask {
	display: none;

	&.active {
		display: block;
		height: 100vh;
		left: 0;
		position: fixed;
		top: 0;
		width: 100vw;
		z-index: 99;
	}
}

@media screen and (max-width: calc(#{$tablet} - 1px)) {
	#ContentPane10 {
		.ad-container-2025, .ad-container-101 {
			background: $grey-bg-color;
			bottom: 0;
			height: 5rem !important;
			min-height: 5rem !important;
			position: fixed;
			width: 100%;
			z-index: 1025;

			&:empty {
				display: inherit;
			}

			& .ad.ad-2025 {
				height: 5rem !important;
				min-height: 5rem !important;
				padding: 1rem 0 0 0;

				> div:first-child {
					&::after {
						bottom: auto;
						color: $grey-label-color;
						left: 50%;
						padding: 0;
						position: absolute;
						top: 0.4375rem;
						transform: translate(-50%);
					}
				}
			}
		}
	}
}

@media screen and (min-width: $max-width) {
	.global-container-1 .ad-container-101 {
		min-height: 8.25rem;

		.ad.ad-101 > div:first-child:after {
			top: .75rem;
		}
	}
}

.webmd-onc {
	.ad-container-121 {
		min-height: 37.5rem;
	}

	.ad.ad-121 {
		align-items: flex-start;
		margin-top: 0;
		position: sticky;
		top: 9.375rem;
	}
}

@media screen and (min-width: 767px) and (max-width: 1024px) {
	html:not(.webmd-cpf):not(.webmd-blogs):not(.webmd-qa-center):not(.webmd-appt-prep) {
		.ad-container-101 {
			background: #f7f7f7;
			bottom: 0;
			position: fixed!important;
			width: 100%;
			z-index: 1025;
		}
	}
}

</style>
